import { menu } from './menu';
import { router } from './router';

export const Skladove = {
	router,
	menu,
};
